import { lazy } from 'react'

import withSuspense from 'app/routes/withSuspense'

const LazyBorrowerRoutes = lazy(() => import('app/routes/BorrowerRoutes/BorrowerRoutes'))

const BorrowerRoutes = withSuspense(LazyBorrowerRoutes)

export default BorrowerRoutes
